import $ from 'jquery';
import niceScroll from 'jquery.nicescroll';

export default class IndexContent {
  constructor(app) {
    this.app = app;
    this.getKV();
    this.getNewsData();
    this.getSp();
    this.getGoods();
  }
  getGoods() {
    var goods_arr;
    var goods_xhr = new XMLHttpRequest();
    goods_xhr.open('get', this.app.host + 'api/goods', true);
    goods_xhr.send();
    goods_xhr.onload = function() {
      if (goods_xhr.status == 200) {
        goods_arr = JSON.parse(goods_xhr.responseText);
        // console.log(goods_arr.data)
        var obj = goods_arr.data;
        for (var x in obj) {

          $('.customer__box').append(
            '<div class="customer__item">' +
            '<div class="customer__item-img">' +
            '<img src="' + this.app.host + obj[x].img_path + '" />' +
            '</div>' +
            '<h3 class="customer__item-title">' + obj[x].title + '</h3>' +
            '<h5 class="customer__item-subtitle">' + obj[x].short_desc + '</h5>' +
            // '<p class="customer__item-text text-center">' + obj[x].content_desc + '</p>' +
            '<p class="customer__item-text text-center"></p>' +
            '<a class="customer__item-button index__button" href="//' + obj[x].url + '">' + obj[x].button_title + '</a>' +
            '</div>'
          )
        }
        if ($('.customer__item').length > 3) {
          // console.log('>3');
          $('.customer__box').removeClass('col-lg-6');
          $('.customer__bg').removeClass('d-lg-block');

          $(".customer__box").slick({
            infinite: true,
            mobileFirst:true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [{
                breakpoint: 320,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
              {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              },
            ]
          });
        } else {
          $('.customer__box').addClass('col-lg-6');
          $('.customer__bg').addClass('d-lg-block');
        }
      }
    }.bind(this)
  }
  getSp() {
    var spProd_arr;
    var spProd_xhr = new XMLHttpRequest();
    spProd_xhr.open('get', this.app.host + 'api/products', true);
    spProd_xhr.send();
    spProd_xhr.onload = function() {
      if (spProd_xhr.status == 200) {
        spProd_arr = JSON.parse(spProd_xhr.responseText);
        // console.log(spProd_arr.data)
        var obj = spProd_arr.data;
        for (var x in obj) {
          for (var i = 0; i < obj[x].length; i++) {
            if (obj[x][i].is_special == true) {
              $('.news .img__slider').append(
                '<div class="news__img">' +
                '<img src="' + this.app.host + obj[x][i].medias[0].path + '" />' +
                '</div>'
              )
            } else {

            }
          }
        }
        $(".img__slider").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false,
          dots: true,
        })
        // this.refreshSlder();
      }
    }.bind(this)
  }
  getKV() {
    var kv_arr;
    var kv_xhr = new XMLHttpRequest();
    kv_xhr.open('get', this.app.host + 'api/kvs', true);
    kv_xhr.send();
    kv_xhr.onload = function() {
      if (kv_xhr.status == 200) {
        kv_arr = JSON.parse(kv_xhr.responseText);
        // console.log(kv_arr.data)
        for (var i = 0; i < kv_arr.data.length; i++) {
          $('.kv-slider').append('' +
            '<div class="kv-slider__item">' +
            '<div class="kv-slider__item__container">' +
            '<a  href="' + kv_arr.data[i].url + '" target="_blank" >' +
            '<img src="' + this.app.host + kv_arr.data[i].img_path + '" />' +
            '</a>' +
            '</div>' +
            '</div>'
          )
        }
        $(".kv-slider").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: false,
          nextArrow: false
        });
        // this.refreshSlder();
      }
    }.bind(this)
  }
  getNewsData() {
    var news_arr;
    var news_xhr = new XMLHttpRequest();
    news_xhr.open('get', this.app.host + 'api/news/index', true);
    news_xhr.send();
    news_xhr.onload = function() {
      if (news_xhr.status == 200) {
        news_arr = JSON.parse(news_xhr.responseText);
        // console.log(news_arr);
        for (var i = (news_arr.data.length-1); i>(news_arr.data.length-4); i--) {
          $('.news__box').append('' +
            '<div class="news__item row">' +
            '<div class="news__item--img col-3">' +
            '<img src="' + this.app.host + news_arr.data[i].medias[0].path + '" />' +
            '</div>' +
            '<div class="news__item--info col-9">' +
            '<h5 class="item__title">' + news_arr.data[i].title + '</h5>' +
            '<p class="item__text">' + news_arr.data[i].short_desc + '</p>' +
            '<a class="button button__readmore" href="./news.html#' + news_arr.data[i].publish_date.split('/')[0] +'?id='+news_arr.data[i].id+'">read more</a>' +
            '</div>' +
            '</div>'
          )
        }

        // $('.news__box').css({
        //   'height': ($('.sp').innerHeight() - 30) + 'px'
        // });
        // $('.news__box').niceScroll();
      }
    }.bind(this)
  }
  setSlider() {


  }
  refreshSlder() {
    $(".kv-slider").slick('setPosition');
    $(".img__slider").slick('setPosition');

  }
  hashchange() {

  }
}
